export function initDealerAddressAutocomplete(lang) {
    const addressInput = document.getElementById("dealerSearchFormAddress");
    const submitButton = document.getElementById("dealerSearchFormSubmit");

    if (submitButton && addressInput) {
        const form = submitButton.closest("form");
        if (form) {
            submitButton.addEventListener("click", (event) => {
                event.preventDefault();
                form.submit();
            });
        }
    }

    const suggestionsList = document.getElementById("addressSuggestions");
    if (!addressInput || !suggestionsList) return;

    let abortController = null;
    let latestRequestId = 0;

    addressInput.addEventListener("input", async function () {
        const query = addressInput.value.trim();
        if (query.length < 3) {
            suggestionsList.innerHTML = "";
            return;
        }

        const requestId = ++latestRequestId;
        if (abortController) abortController.abort();
        abortController = new AbortController();

        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&accept-language=${lang}`,
                {signal: abortController.signal}
            );
            const data = await response.json();
            if (requestId !== latestRequestId) return;

            suggestionsList.innerHTML = "";
            data.forEach(place => {
                const item = document.createElement("li");
                item.textContent = place.display_name;
                item.addEventListener("click", () => {
                    addressInput.value = place.display_name;
                    document.getElementById("latitude").value = place.lat;
                    document.getElementById("longitude").value = place.lon;
                    suggestionsList.innerHTML = "";
                });
                suggestionsList.appendChild(item);
            });
        } catch (error) {
            if (error.name !== "AbortError") {
                console.error("Fehler bei der Adresseingabe:", error);
            }
        }
    });
}
